import { render, staticRenderFns } from "./InscriptionEdit.html?vue&type=template&id=4a254e85&external"
import script from "./InscriptionEdit.ts?vue&type=script&lang=ts&external"
export * from "./InscriptionEdit.ts?vue&type=script&lang=ts&external"
import style0 from "./InscriptionEdit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports